module.exports = __webpack_public_path__ + "img/pr-2.3ebf455a.png";